import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import PromotionShareAccept from './PromotionShareAccept';
import ExtraTips from './ExtraTips';
import IntegrationsStatus from './IntegrationsStatus';
import PromoExceededs from './PromoExceededs';
import MainStats from './MainStats';
import PendingMatchesBracketsWarning from './PendingMatchesBracketsWarning';
import PromoDatesResumee from './PromoDatesResumee';
import PromoMainInfo from './PromoMainInfo';
import PromoStatus from './PromoStatus';
import ToDoList from './ToDoList';

import ActionLink from '../builder/ActionLink';
import { AlertMessage } from '../builder/Message';

import OwnerPromoWrapper from '../ui_items/OwnerPromoWrapper.js';
import { useOwner } from '../context/context.js';
import MainPromoLink from '../backend/MainPromoLink.js';
import SMSPacksStatus from '../backend/SMSPacksStatus.js';
import TestInvitations from '../backend/elements/TestInvitations.js';
import PremoderationAccess from './PremoderationAccess.js';
import OCRPacksStatus from '../backend/TicketOcr/OCRPacksStatus.js';
import { agent_roles } from '../account/bootstrap.js';

const PromoProfile = ({ ...props }) => {
	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	
	const role = props?.role ?? 'administrator';
	const agent_promotion_role = parseInt(props?.agent_promotion_role ?? 1);//Else ADMIN
	const is_analyst = (role == 'analyst' || agent_promotion_role == agent_roles.ROLE_ANALYST.id) ? true : false;
	const is_editor = (role == 'editor' || agent_promotion_role == agent_roles.ROLE_EDITOR.id) ? true : false;
	
	const status = owner?.status ?? 'draft';

	let display_test = promotion?.test ?? false;
	if(status == 'old' || status == 'expired') display_test = false;

	const toggleInvitations = () => {
		window.handleTestButton.toggleInvitations();
	};

	const archived_promo = (promotion.archived != undefined && promotion.archived == '1') ? true : false;
	const display_warning = (!promotion.sign_fb && !promotion.need_email && !promotion.hide_enter_button) ? true : false;
	const total_exceeded = props?.exceededs ?? 0;

	let has_ocr_ticket_validation_stages = false;
	Object.values(props?.stages ?? {}).map((st) => {
		if((st?.Stage?.reqs_type ?? '1') == '8') has_ocr_ticket_validation_stages = true;
	});

	return (
		<OwnerPromoWrapper add_module={false} {...props} selected='profile' simple_header={false}>
			{(owner.trully_expired) && (//has Plan + 30 days
				<AlertMessage
					icon={false}
					_class={{ other:'whiteColor redBg in_top in_bottom gui_not_bordered shadow_small' }}
				>	
					<p class="gui_force_bold gui_uppercase">{i18n("Closed promotion")}</p>
					<p>{props.intl.formatMessage({ id:"The promotion was closed on {date}." }, { date:EPDateFormat(promotion.end_date, 'LL')})}</p>
					<p><ActionLink _href={`${window.zendesk_base_url}23041559616532`} _target="_blank" _class={{other:'gui_underlined_text whiteColor gui_force_bold submit_link'}}>More information</ActionLink></p>
				</AlertMessage>
			)}
			
			{(!owner.trully_expired && status == 'expired') && (
				<AlertMessage
					icon={false}
					_class={{ other:'whiteColor redBg in_top in_bottom gui_not_bordered shadow_small' }}
				>
					<p class="gui_force_bold gui_uppercase">{i18n("Promotion closure")}</p>
					<p>{props.intl.formatMessage({ id:"The promotion will close automatically on {date} at {hour} {tz}." }, { date:EPDateAddAndFormat(promotion.end_date, 'months', 1, 'LL'), hour:EPDateFormat(promotion.end_date, 'h:mm'), tz:` ${defaultTimezones(promotion.timezone)}`})}</p>
					<p>{i18n("When the promotion is closed, you must maintain an active plan to access and download the user list, view statistics, and modify the configuration.")}</p>
					<p><ActionLink _href={`${window.zendesk_base_url}23041559616532`} _target="_blank" _class={{other:'gui_underlined_text whiteColor gui_force_bold submit_link'}}>More information</ActionLink></p>
				</AlertMessage>
			)}

			{(display_test) && (
				<TestInvitations
					promotion_id={promotion.id}
					intl={props.intl}
				/>
			)}

			<MainPromoLink
				domain={props.domain}
				languages={props.languages}
			/>

			<div class="gui_grid is_profile">
				<div class="gui_grid">
					{(promotion.promo_type == '0' && (promotion.promotion_type_id != '1' || promotion.public_entries != '0')) && (
						<AlertMessage
							_class={{ other:'in_top in_bottom' }}
							title="Important notice"
						>
							<p>{i18n("From 1 February 2021, voting based contests will no longer be supported in Basic version.")}</p>

							<p><strong>{i18n("Please, use Premium version for voting contests.")}</strong></p>
						</AlertMessage>
					)}

					{(/*role != 'analyst'*/ !is_analyst) && (
						<PromoStatus {...props} />
					)}

					{((status != 'draft' && !archived_promo && !is_editor)) && (
						<MainStats {...props} />
					)}

					{/*<ExpectedNumUsers {...props} />*/}

					{(status == 'draft') && (
						<PromoDatesResumee {...props} />
					)}

					{(status == 'active') && (
						<PromoMainInfo {...props} />
					)}

					<PromotionShareAccept {...props} />
				</div>

				<div class="gui_grid">
					{(false && status != 'draft' && !archived_promo && !is_editor && total_exceeded > 0) && (
						<PromoExceededs {...props} />
					)}

					{(promotion?.login_net_sms ?? false) && (
						<SMSPacksStatus
							{...props}
							is_builder={true}
							add_module={true}
							account_id={promotion.account_id}
						/>
					)}

					{(has_ocr_ticket_validation_stages) && (
						<OCRPacksStatus
							{...props}
							is_builder={true}
							add_module={true}
							account_id={promotion.account_id}
						/>
					)}

					{(/*role != 'analyst'*/ !is_analyst) && (
						<IntegrationsStatus {...props} />
					)}

					{((!['old','draft','expired'].includes(status) || display_test)  && [agent_roles.ROLE_ADMIN.id, 
																						agent_roles.ROLE_MANAGER.id, 
																						agent_roles.ROLE_PREMODERATOR.id, 
																						agent_roles.ROLE_EDITOR.id].includes(agent_promotion_role)) && (
						<PremoderationAccess {...props} />
					)}

					{(display_warning) && (
						<AlertMessage
							title="Warning"
							_class={{ other:'in_top in_bottom' }}
						>
							<p>{i18n("In order to identify unique participants, require users' email address in the registry form, or make mandatory for users to connect on Facebook to register.")} (<ActionLink _href={`/promotions/builder/${promotion.id}#signin`} _target="_self">Fix this</ActionLink>)</p>
						</AlertMessage>
					)}

					{(status == 'draft') && (
						<PromoMainInfo {...props} />
					)}

					{(/*role != 'analyst'*/ !is_analyst) && (
						<PendingMatchesBracketsWarning
							brackets={props.brackets}
							promotion_id={promotion.id}
						/>
					)}

					{(/*role != 'analyst'*/ !is_analyst) && (
						<ToDoList {...props} />
					)}

					{(status == 'active' && /*role != 'analyst'*/ !is_analyst) && (
						<ExtraTips {...props} />
					)}
				</div>
			</div>
		</OwnerPromoWrapper>
	);
}

export default injectIntl(PromoProfile);